// extracted by mini-css-extract-plugin
export default {"contents":"cE-z","sectionHeading":"dE-z"};